<template>
  <div class="add-to-cart">
    <div class="mb-2">
      <button type="button" @click="aumentar" class="mr-1 btn btn-outline-dark btn-sm">+</button>
      <span>{{cantidad}}</span>
      <button type="button" @click="disminuir" class="ml-1 btn btn-outline-dark btn-sm">-</button>
    </div>
    <button class="btn btn-dark" @click="addToCart">Cotizar</button>
  </div>
</template>

<script>
export default {
  name: "add-to-cart",
  props: {
    name: String,
    tag: String,
    line: String,
    image: String,
    pId: String
  },

  data() {
    return {
      item: {
        productName: this.name,
        productImage: this.image,
        productTag: this.tag,
        productLine: this.line,
        productId: this.pId,
        productQuantity: 1
      },
      cantidad: 1
    };
  },
  methods: {
    aumentar(product) {
      return this.cantidad++;
    },
    disminuir(product) {
      if (this.cantidad > 1) {
        return this.cantidad--;
      }
    },
    cuantos() {
      if (this.cantidad) {
        return (this.item.productQuantity = parseInt(this.cantidad));
      }
    },
    addToCart() {
      $("#miniCart").modal("show");
      this.cuantos();
      this.$store.commit("addToCart", this.item);
      this.cantidad = 1;
    }
  },
  computed: {}
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
